import { style } from '@vanilla-extract/css';

export const figcaptionWrapper = style({
  paddingLeft: 'var(--wt-image-source-padding-left)',
  paddingRight: 'var(--wt-image-source-padding-right)',
  paddingTop: 'var(--wt-image-source-padding-top)',
  paddingBottom: 'var(--wt-image-source-padding-bottom)',
  margin: 'var(--wt-image-alignment-margins, 0px)',
  width: 'var(--wt-image-width-percent, 100%)',
  textAlign: 'var(--caption-alignment, var(--wt-image-source-alignment, left))',
});

export const linkedFigcaptionWrapper = style({
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
});
